import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, FreeMode } from "swiper/modules";
import "swiper/css";
import "swiper/css/free-mode";
import Image from "../../../components/AppImage";

const BrandCarousel = () => {
  const brands = [
    { name: "Suzuki", logo: "/1.webp" },
    { name: "Tata", logo: "/2.webp" },
    { name: "Hyundai", logo: "/3.webp" },
    { name: "Mahindra", logo: "/4.webp" },
    { name: "Honda", logo: "/5.webp" },
    { name: "Toyota", logo: "/6.webp" },
    { name: "Kia", logo: "/7.webp" },
    { name: "MG", logo: "/8.webp" },
    { name: "Skoda", logo: "/9.webp" },
    { name: "volkswagen", logo: "/10.webp" },
    { name: "Ford", logo: "/11.webp" },
    { name: "chevrolet", logo: "/12.webp" },
    { name: "Fiat", logo: "/13.webp" },
    { name: "Datsun", logo: "/14.webp" },
    { name: "Nissan", logo: "/15.webp" },
  ];

  return (
    <section className="pb-16 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 lg:px-6">
        {/* Heading */}
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-text-primary mb-4">
            Trusted by Leading Automotive Brands
          </h2>
          <p className="text-xl text-text-secondary max-w-2xl mx-auto">
            Our partnerships with India’s top car manufacturers and aftermarket
            suppliers make us one of the most trusted genuine auto parts
            dealers. We guarantee authentic original products, timely delivery,
            and global shipping to every customer.
          </p>
        </div>

        {/* Smooth Moving Carousel */}
        <Swiper
          modules={[Autoplay, FreeMode]}
          freeMode={true}
          loop={true}
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
          }}
          speed={4000} // controls speed of continuous movement
          spaceBetween={30}
          slidesPerView={2}
          breakpoints={{
            640: { slidesPerView: 3 },
            768: { slidesPerView: 4 },
            1024: { slidesPerView: 6 },
          }}
          className="pb-6"
        >
          {brands.map((brand, index) => (
            <SwiperSlide key={index}>
              <div className="w-full h-24 bg-white rounded-xl shadow-automotive-sm border border-border flex items-center justify-center group hover:shadow-automotive-lg transition">
                <Image
                  src={brand.logo}
                  alt={brand.name}
                  className="max-h-12 object-contain grayscale group-hover:grayscale-0 transition"
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default BrandCarousel;
